import { Injectable } from '@angular/core'
import { ActivatedRoute, ChildActivationEnd, NavigationEnd, Router } from '@angular/router'
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs'
import { filter } from 'rxjs/operators'

import { RouteData } from '../models'

@Injectable()
export class NavigationService {
	_sideNavVisible$ = new BehaviorSubject(true)
	_routeData$ = new BehaviorSubject({} as RouteData)

	_currentURL$ = new BehaviorSubject('')
	_previousURL$ = new BehaviorSubject('')

	constructor(
		public router: Router,
		private ar: ActivatedRoute
	) {
		this.router.events.pipe(filter(event => event instanceof ChildActivationEnd)).subscribe(event => {
			let snapshot = (event as ChildActivationEnd).snapshot

			while (snapshot.firstChild !== null) {
				snapshot = snapshot.firstChild
			}

			const data = Object.keys(snapshot.data).length > 0 ? snapshot.data : snapshot.parent?.data

			this._routeData$.next(data as RouteData)
		})

		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
			this._previousURL$.next(this._currentURL$.value)
			this._currentURL$.next(router.url)
		})
	}

	async backClicked() {
		const previousURL = await firstValueFrom(this.previousURL$())
		const url = previousURL || '/dashboard'
		await this.router.navigate([url], { relativeTo: this.ar })
	}

	sideNavVisible$(): Observable<boolean> {
		return this._sideNavVisible$
	}

	toggleSideNav() {
		this._sideNavVisible$.next(!this._sideNavVisible$.value)
	}

	closedSideNav() {
		this._sideNavVisible$.next(false)
	}

	openedSideNav() {
		this._sideNavVisible$.next(true)
	}

	routeData$(): Observable<RouteData> {
		return this._routeData$
	}

	currentURL$(): Observable<string> {
		return this._currentURL$
	}

	previousURL$(): Observable<string> {
		return this._previousURL$
	}
}
